module.exports = __webpack_public_path__ + "img/Contractor.c2638f10.svg";